$(document).ready(() => {
    const passwordModalOverlay = $('.forget_password_overlay');
    const passwordModalDialog = $('.forget_password_form');

    const loginModalOverlay = $('.header__login-form-overlay');
    const loginModalDialog = $('.header__login-form');

    const signupModalOverlay = $('.header__signUp-form-overlay');
    const signupModalDialog = $('.header__signUp-form');

    const closeLoginModal = () => {
        loginModalOverlay.removeClass('header__login-form-overlay-visible');
        loginModalDialog.removeClass('header__login-form-visible');
        loginModalDialog.find('input').val('');
    };
    const openLoginModal = () => {
        loginModalOverlay.toggleClass('header__login-form-overlay-visible');
        loginModalDialog.toggleClass('header__login-form-visible');
    };
    window.closeLoginModal = closeLoginModal;
    window.openLoginModal = openLoginModal;

    const closeSignupModal = () => {
        signupModalOverlay.removeClass('header__signUp-form-overlay-visible');
        signupModalDialog.removeClass('header__signUp-form-visible');
        signupModalDialog.find('input').val('');
    };
    window.closeSignupModal = closeSignupModal;
    $('.header_form_close').on('click', closeSignupModal);

    const closePasswordModal = () => {
        passwordModalOverlay.removeClass('forget_password_overlay_visible');
        passwordModalDialog.removeClass('forget_password_form_visible');
        $('body').css('overflow-y', '');
    };
    window.closePasswordModal = closePasswordModal;
    $('.header_form_close').on('click', closePasswordModal);

    loginModalOverlay.click(closeLoginModal);
    $('.header_form_close').on('click', closeLoginModal);
    passwordModalOverlay.click(closePasswordModal);
    signupModalOverlay.click(closeSignupModal);

    $('.login__open').click(() => {
        closeSignupModal();
        openLoginModal();
    });

    $('.signUp__open').click(() => {
        closeLoginModal();
        signupModalOverlay.toggleClass('header__signUp-form-overlay-visible');
        signupModalDialog.toggleClass('header__signUp-form-visible');
    });

    $('.header__login-form_new_password').click(() => {
        closeLoginModal();
        passwordModalOverlay.toggleClass('forget_password_overlay_visible');
        passwordModalDialog.toggleClass('forget_password_form_visible');
        $('body').css('overflow-y', 'hidden');
    });

    $('.forget_password_form_login').click(() => {
        closePasswordModal();
        loginModalOverlay.toggleClass('header__login-form-overlay-visible');
        loginModalDialog.toggleClass('header__login-form-visible');
    });

    $(document).keyup(function (e) {
        if (e.keyCode === 27) {
            closeLoginModal();
            closePasswordModal();
            closeSignupModal();
        }
    });
});
